import ApiAuthorzationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { TerminalManagement } from './components/Management/TerminalManagement';
import { Refunds } from './components/Refunds/Refunds';
import UserManagementPage from './components/Users/UserManagementPage';
import AuthRedirector from './components/AuthRedirector';
import { ReportsPage } from './components/Reports/ReportsPage';
import { UploadRefunds } from './components/Refunds/Upload/UploadRefunds';
import { EmailSettings } from './components/EmailSettings/EmailSettings';
import { Cards } from './components/Cards/Cards';
import { ApiKeysPage } from './components/ApiKeys/ApiKeysPage';
import { ApiDocsPage } from './components/ApiKeys/ApiDocsPage';

interface AppRoute {
  index?: boolean;
  path: string;
  element: JSX.Element;
  name?: string;
  requireAuth?: boolean;
  roles?: string[];
  navGroup?: 'primary' | 'system';
}

const AppRoutes: AppRoute[] = [
  {
    path: '/',
    element: <AuthRedirector />,
  },
  {
    path: '/management',
    requireAuth: true,
    element: <TerminalManagement />,
    roles: ['Admin', 'TerminalManager'], // Исправлено: 'Manager' на 'TerminalManager'
    name: 'АЗС и терминалы',
    navGroup: 'system'
  },
  {
    path: '/refunds',
    requireAuth: true,
    element: <Refunds />,
    roles: ['Admin', 'RefundManager', 'RefundViewer'], // Исправлено: 'Operator' на 'RefundManager', 'RefundViewer'
    name: 'Возвраты',
    navGroup: 'primary'
  },
  {
    path: '/refunds/upload',
    requireAuth: true,
    element: <UploadRefunds />,
    roles: ['Admin'],
    name: 'Загрузка возвратов',
    navGroup: 'system'
  },
  {
    path: '/reports',
    requireAuth: true,
    element: <ReportsPage />,
    roles: ['Admin', 'RefundManager', 'RefundViewer'],
    name: 'Отчеты',
    navGroup: 'primary'
  },
  {
    path: '/email-settings',
    requireAuth: true,
    element: <EmailSettings />,
    roles: ['Admin'],
    name: 'Настройки Email',
    navGroup: 'system'
  },
  {
    path: '/user-management',
    requireAuth: true,
    element: <UserManagementPage />,
    roles: ['Admin'],
    name: 'Пользователи',
    navGroup: 'system'
  },
  {
    path: '/cards',
    requireAuth: true,
    element: <Cards />,
    roles: ['Admin'],
    name: 'Карты',
    navGroup: 'system'
  },
  {
    path: '/api-keys',
    requireAuth: true,
    element: <ApiKeysPage />,
    roles: ['Admin'],
    name: 'API ключи',
    navGroup: 'system'
  },
  {
    path: '/api-docs',
    requireAuth: true,
    element: <ApiDocsPage />,
    roles: ['Admin']
  },
  ...(ApiAuthorzationRoutes as AppRoute[])
];

export default AppRoutes;
